<div class="flex flex-col lg:flex-row items-center lg:space-x-10">
    <div class="flex flex-1 flex-col space-y-8">
        <h2 class="text-3xl font-semibold">Lidt om mig</h2>
        <p>
            Gennem mine snart 10 år som proffesional software udvikler, har jeg
            opnået en masse erfaring, som jeg nu ønsker at dele med nye
            samarbejdspartnere ved at arbejde freelance.
        </p>
        <p>
            Lille webshop til din hobby, eller en stor SaaS løsning ? <br />
            Jeg har prøvet begge dele, og det meste imellem.
        </p>
    </div>
    <div class="flex-1 flex justify-around">
        <img src="/about.png" alt="" />
    </div>
</div>
  